import React from 'react';
import { IoMdDocument, IoMdPerson } from 'react-icons/io';
import { FaCamera, FaVideo } from 'react-icons/fa';
import { BsFillMicFill } from 'react-icons/bs';
import { getFileTypeName, isSourceExpired } from '../../utils';
import {
  ChatBallonResponseReply,
  ReplyContent,
  ReplyContentInfo,
  ReplyIcon,
  ReplySender,
  ReplyText,
  ReplyTextPreview,
  ReplyImagePreview,
  ReplyStickerPreview
} from '../styled';

const ReplyMessage = ({
  context,
  handleScrollToMessage,
  color,
  backgroundColor,
  textColor
}) => {
  const isExpired = isSourceExpired(context.source, context.time);

  const modifiedContextIfExpired =
    isExpired !== undefined && isExpired
      ? {
          ...context,
          response_type: 'text',
          texto: 'Link expirado com mais de 7 dias.',
          source: ''
        }
      : context;

  const getReplyIcon = (type) => {
    switch (type) {
      case 'file':
        return <IoMdDocument size={12} />;
      case 'image':
        return <FaCamera size={12} />;
      case 'audio':
        return <BsFillMicFill size={12} />;
      case 'video':
        return <FaVideo size={12} />;
      case 'contact':
        return <IoMdPerson size={12} />;
      default:
        return null;
    }
  };

  return (
    modifiedContextIfExpired && (
      <ChatBallonResponseReply
        color={color}
        backgroundColor={backgroundColor}
        onClick={handleScrollToMessage}
      >
        <ReplyContent>
          {['file', 'image', 'audio', 'video', 'contact'].includes(
            modifiedContextIfExpired.response_type
          ) && (
            <ReplyContentInfo
              isFullWidth={['file', 'video', 'contact'].includes(
                modifiedContextIfExpired.response_type
              )}
            >
              <ReplySender textColor={textColor}>
                {modifiedContextIfExpired.escrita_por}
              </ReplySender>
              <div
                style={{
                  maxWidth: '100%'
                }}
              >
                <ReplyIcon>
                  {getReplyIcon(modifiedContextIfExpired.response_type)}
                </ReplyIcon>
                <ReplyText textColor={textColor}>
                  {modifiedContextIfExpired.response_type === 'contact' ? (
                    <>
                      {modifiedContextIfExpired.contact[0].name.formatted_name}
                    </>
                  ) : (
                    modifiedContextIfExpired.description ||
                    getFileTypeName(modifiedContextIfExpired.response_type)
                  )}
                </ReplyText>
              </div>
            </ReplyContentInfo>
          )}
          {modifiedContextIfExpired.response_type === 'text' && (
            <ReplyTextPreview>
              <ReplySender>{modifiedContextIfExpired.escrita_por}</ReplySender>
              <ReplyText>{modifiedContextIfExpired.texto}</ReplyText>
            </ReplyTextPreview>
          )}
          {modifiedContextIfExpired.response_type === 'image' && (
            <ReplyImagePreview
              style={{
                backgroundImage: `url(${modifiedContextIfExpired.source})`
              }}
            />
          )}
          {modifiedContextIfExpired.response_type === 'sticker' && (
            <ReplyStickerPreview
              style={{
                backgroundImage: `url(${modifiedContextIfExpired.source})`
              }}
            />
          )}
        </ReplyContent>
      </ChatBallonResponseReply>
    )
  );
};

export default ReplyMessage;
